import { forwardRef } from "react";
import { AppMenu } from "../../../../shared/components/AppMenu";
import { AppMenuProps } from "../types";

export const MenuBasic = forwardRef<HTMLDivElement, AppMenuProps>(
  (
    { isOpen, position, children, leftPos = 35, verticalPos = 0, ...rest },
    ref,
  ) => {
    return (
      <AppMenu
        open={isOpen}
        anchorReference={"anchorPosition"}
        anchorPosition={{
          left: (position?.x ?? 0) + leftPos,
          top: (position?.y ?? 0) + verticalPos,
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        ref={ref}
        {...rest}
      >
        {children}
      </AppMenu>
    );
  },
);
